// FILE: src/components/feedback/feedbackStyles.js
//
// Shared style tokens + small helpers for the Admin Feedback Hub. Keeps the
// individual feedback components lean and visually consistent with the rest of
// the admin surface (AdminScreen.js color language).

export const STATUS_COLORS = {
  'New':         { bg: '#e3f2fd', fg: '#1565c0' },
  'In Progress': { bg: '#fff3e0', fg: '#e07b00' },
  'Released':    { bg: '#e0f2f1', fg: '#00897b' },
  'Closed':      { bg: '#eceff1', fg: '#546e7a' },
};

export const SEVERITY_COLORS = {
  High:   { bg: '#ffebee', fg: '#c62828' },
  Medium: { bg: '#fff8e1', fg: '#b8860b' },
  Low:    { bg: '#f1f8e9', fg: '#558b2f' },
};

export function pill(colorMap, key) {
  const c = colorMap[key] || { bg: '#f0f0f0', fg: '#777' };
  return {
    display: 'inline-block', padding: '2px 10px', borderRadius: '12px',
    fontSize: '0.72rem', fontWeight: 700, background: c.bg, color: c.fg,
    letterSpacing: '0.3px', whiteSpace: 'nowrap',
  };
}

export function formatDate(iso) {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleDateString(undefined, {
      year: 'numeric', month: 'short', day: 'numeric',
    });
  } catch (_) {
    return String(iso).slice(0, 10);
  }
}

export const certLabel = (id) => {
  if (!id) return '—';
  const map = { pmp: 'PMP', cpmai: 'CPMAI', 'pmi-acp': 'PMI-ACP', 'pmi-pmocp': 'PMI-PMOCP' };
  return map[id] || id;
};

export const styles = {
  wrapper: {
    fontFamily: "'Segoe UI', system-ui, sans-serif", minHeight: '100vh',
    background: '#f5f5f5', display: 'flex', flexDirection: 'column',
  },
  header: {
    background: '#1a1a2e', color: '#fff', padding: '16px 28px',
    display: 'flex', alignItems: 'center', gap: '16px', flexShrink: 0,
  },
  backButton: {
    padding: '6px 14px', background: 'transparent', border: '1px solid #555',
    borderRadius: '4px', color: '#ccc', cursor: 'pointer', fontSize: '0.85rem', flexShrink: 0,
  },
  headerTitle: { fontSize: '1.15rem', fontWeight: 'bold', flex: 1, letterSpacing: '0.5px' },
  body: { flex: 1, padding: '28px 32px', maxWidth: '1100px', margin: '0 auto', width: '100%', boxSizing: 'border-box' },
  cardRow: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '14px', marginBottom: '24px' },
  card: { background: '#fff', border: '1px solid #e0e0e0', borderRadius: '10px', padding: '16px 18px' },
  cardNum: { fontSize: '1.8rem', fontWeight: 800, color: '#1a1a2e', lineHeight: 1.1 },
  cardLabel: { fontSize: '0.75rem', color: '#777', textTransform: 'uppercase', letterSpacing: '0.5px', marginTop: '6px' },
  tabRow: { display: 'flex', gap: '6px', marginBottom: '20px', borderBottom: '1px solid #e0e0e0' },
  tab: (active) => ({
    padding: '10px 18px', border: 'none', borderBottom: active ? '3px solid #2c63ff' : '3px solid transparent',
    background: 'transparent', cursor: 'pointer', fontSize: '0.92rem',
    fontWeight: active ? 700 : 500, color: active ? '#1a347d' : '#666',
  }),
  filterBar: { display: 'flex', flexWrap: 'wrap', gap: '10px', marginBottom: '16px', alignItems: 'center' },
  input: { padding: '8px 12px', fontSize: '0.9rem', border: '1px solid #ccc', borderRadius: '6px', color: '#333' },
  select: { padding: '8px 12px', fontSize: '0.9rem', border: '1px solid #ccc', borderRadius: '6px', background: '#fff', color: '#333', cursor: 'pointer' },
  table: { width: '100%', borderCollapse: 'collapse', background: '#fff', border: '1px solid #e0e0e0', borderRadius: '10px', overflow: 'hidden' },
  th: { textAlign: 'left', padding: '10px 12px', fontSize: '0.74rem', textTransform: 'uppercase', letterSpacing: '0.4px', color: '#888', borderBottom: '1px solid #eee', background: '#fafafa' },
  td: { padding: '10px 12px', fontSize: '0.85rem', color: '#333', borderBottom: '1px solid #f0f0f0', verticalAlign: 'top' },
  row: (selected) => ({ cursor: 'pointer', background: selected ? '#eef2ff' : 'transparent' }),
  empty: { padding: '40px', textAlign: 'center', color: '#999', fontSize: '0.95rem' },
  primaryBtn: { padding: '9px 18px', background: '#2c63ff', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '0.9rem', fontWeight: 700 },
  secondaryBtn: { padding: '9px 18px', background: 'transparent', color: '#555', border: '1px solid #bbb', borderRadius: '6px', cursor: 'pointer', fontSize: '0.9rem' },
  label: { fontSize: '0.82rem', fontWeight: 600, color: '#444', display: 'block', marginBottom: '6px' },
  textarea: { padding: '10px 12px', fontSize: '0.9rem', border: '1px solid #ccc', borderRadius: '6px', resize: 'vertical', minHeight: '70px', fontFamily: 'inherit', width: '100%', boxSizing: 'border-box', color: '#333' },
};
